<template>
  <div class="imgUploader">
    <div class="file-list">
      <section v-for="(file, index) in imgStore" :key="index" class="file-item draggable-item">
        <img :src="file.src" alt="" ondragstart="return false;" />
        <span class="file-remove" @click="remove(file.key)">+</span>
        <span class="flie-loading" v-if="imgStatus === 'uploading'">上传中...</span>
        <span class="flie-finished" v-if="imgStatus === 'finished'">已上传</span>
      </section>
      <section class="file-item" v-if="imgStatus !== 'finished' && imgStore.length < 5">
        <div class="add">
          <span>
            <!--<i class="fa fa-camera"></i>
            <div class="fa-camera-font">图片</div>-->
            <img src="/static/icon/photo.png" alt="" />
          </span>
          <!-- accept="image/jpeg,image/png" capture="camera" -->
          <input type="file" multiple accept="image/*" @change="selectImgs" ref="file" />
        </div>
      </section>
    </div>
    <div class="uploadBtn">
      <!-- <section class='originCheckbox'>
        <input type="checkbox" name="" id="originImg" v-model="originImg">
        <label for="originImg">原图上传(不建议勾选)</label>
      </section>-->
      <section>
        <span v-if="imgStore.length > 0" class="empty" @click="empty">
          {{ imgStatus === 'finished' ? '重新上传' : '清空' }}
        </span>
      </section>
      <div class="originCheckbox">提示：若图片太大请尝试截图后上传</div>
    </div>
    <dingtalk></dingtalk>
  </div>
</template>
<script>
/* eslint-disable */
import { Indicator } from 'mint-ui'
import { photoCompress, dataURLtoFile, dataURLToBlob } from './scripts/imgCompress.js'
import { mapState } from 'vuex'
import { result } from 'lodash'
import { upload } from '@/apis/fromBaseApi/additionalInfo'
export default {
  props: ['url'],
  data() {
    return {
      originImg: false,
      filesOrigin: [], // 原始文件
      filesCompress: [], // 压缩后的图片
      indexOrigin: 0, // 原始文件序列号
      indexCompress: 0, // 压缩后的图片序列号
      maxLength: 5, // 图片最大数量
      imgUrlPaths: [], // 图片上传成功返回路径
      UploadFlag: 0 // 图片上传成功数量
    }
  },
  components: {
    dingtalk: {
      render(createElement) {
        return createElement('script', {
          attrs: {
            type: 'text/javascript',
            src: 'https://gosspublic.alicdn.com/aliyun-oss-sdk-4.4.4.min.js'
          }
        })
      }
    }
  },
  computed: {
    ...mapState({
      imgStoreCompress: (state) => state.imgstore.img_upload_cache_compress.slice(0, 5),
      imgStore: (state) => state.imgstore.img_upload_cache.slice(0, 5),
      imgPaths: (state) => state.imgstore.img_paths,
      imgStatus: (state) => state.imgstore.img_status
    })
  },
  methods: {
    // 选择图片
    selectImgs(data) {
      console.log(3213132)
      if (data.target.files.length > 5 || this.filesOrigin.length + data.target.files.length > 5) {
        this.$toast('一次最多只能上传5张图片!')
        this.empty()
        return
      }
      let fileList = this.$refs.file.files
      // 存储原始图片
      for (let i = 0, len = fileList.length; i < len; i++) {
        let fileType = fileList[i].type.split('/')[1].toLowerCase()
        if (fileType !== 'jpg' && fileType !== 'jpeg' && fileType !== 'png') {
          this.$toast('只支持 jpg, jpeg, png 格式的图片!')
          return
        }
        let item = {
          key: this.indexOrigin++,
          name: fileList[i].name,
          size: fileList[i].size,
          file: fileList[i]
        }
        // 将图片文件转成BASE64格式
        let reader = new FileReader()
        reader.onload = (e) => {
          this.$set(item, 'src', e.target.result)
        }
        reader.readAsDataURL(fileList[i])
        this.filesOrigin.push(item)
      }
      this.filesOrigin.splice(5)
      this.$store.commit('set_img_upload_cache', this.filesOrigin.slice(0, 5)) // 存储文件缓存
      this.$store.commit('set_img_status', 'selected') // 更新文件上传状态
      // 存储压缩后的图片
      for (let i = 0, len = fileList.length; i < len; i++) {
        let item = {
          key: this.indexCompress++,
          name: fileList[i].name,
          size: fileList[i].size,
          file: fileList[i]
        }
        // 将图片文件转成BASE64格式
        let reader = new FileReader()
        reader.onload = (e) => {
          this.$set(item, 'src', e.target.result)
        }
        reader.readAsDataURL(fileList[i])
        // console.log(`图片[${i}]，原图：${fileList[i].size / 1024}KB`);
        if (fileList[i].size / 1024 / 500 < 1) {
          // 图片小于500KB不进行压缩，如进行压缩图片大小可能会增大
          this.filesCompress.push(item)
          this.filesCompress.splice(5)
          this.$store.commit('set_img_upload_cache_compress', this.filesCompress.slice(0, 5)) // 存储文件缓存
        } else {
          // 对图片尺寸大于500KB的图片进行压缩
          photoCompress(
            fileList[i],
            {
              quality: 0.8
            },
            (base64Codes) => {
              // console.log(`图片[${i}]，压缩后：${base64Codes.length / 1024}KB`);
              let file = dataURLToBlob(base64Codes, item.name)
              item.file = file
              item.name = file.name ? file.name : item.name
              item.size = file.size
              this.filesCompress.push(item)
              this.filesCompress.splice(5)
              this.$store.commit('set_img_upload_cache_compress', this.filesCompress.slice(0, 5)) // 存储文件缓存
            }
          )
        }
      }
      this.$store.commit('set_img_status', 'selected') // 更新文件上传状态
    },
    // 上传图片
    submit() {
      let vm = this
      //      let formData = new FormData()

      // 原图上传
      this.imgStore.forEach((item) => {
        vm.funUploadFile(item.file)
        console.log(item.file, 321321)
        //          formData.append(`imgFiles[${index}]`, item.file)
      })

      // 压缩上传
      // if (this.imgStoreCompress.length !== this.imgStore.length) {
      //   this.$toast('图片压缩处理中，请稍后...')
      //   this.$store.commit('set_img_status', 'selected') // 更新文件上传状态
      //   return
      // }
      // this.imgStoreCompress.forEach((item) => {
      //   vm.funUploadFile(item.file)
      //   console.log(item.file, 12313)

      //   //          formData.append(`imgFiles[${index}]`, item.file)
      // })

      //      // CN新建请求
      //      const xhr = new XMLHttpRequest()
      //      xhr.open('POST', this.url, true)
      //      xhr.send(formData)
      //      xhr.onload = () => {
      //        if (xhr.status === 200 || xhr.status === 304) {
      //          let datas = JSON.parse(xhr.responseText)
      //          let flag = true
      //          datas.forEach(data => {
      //            if (data.error === -1) {
      //              flag = false
      //            }
      //          })
      //          // 存储返回的地址
      //          if (flag) {
      //            let imgUrlPaths = []
      //            datas.forEach(e => { // error === 0为成功状态
      //              e.error === 0 && imgUrlPaths.push(e.url)
      //            })
      //            this.$store.commit('set_img_paths', imgUrlPaths) // 存储返回的地址
      //            this.filesOrigin = [] // 清空文件缓存
      //            this.indexOrigin = 0 // 初始化序列号
      //            this.$store.commit('set_img_status', 'finished') // 更新文件上传状态
      //          } else {
      //            alert('图片上传失败，请重新上传!')
      //            this.$store.commit('set_img_status', 'ready') // 更新文件上传状态
      //            this.empty()
      //            flag = true
      //          }
      //        } else {
      //          this.$toast(`${xhr.status} 请求错误!`)
      //        }
      //      }
    },

    // 新写的上传文件
    funUploadFile(file) {
      Indicator.open()
      let vm = this
      const form = new FormData()
      form.append('file', file)
      upload(form)
        .then((res) => {
          Indicator.close()
          vm.imgUrlPaths.push(res.data.file_url)
          vm.UploadFlag += 1
          if (vm.UploadFlag === vm.imgStore.length && vm.imgStore.length !== 0) {
            vm.$store.commit('set_img_paths', vm.imgUrlPaths)
            vm.filesOrigin = []
            vm.indexOrigin = 0
            vm.$store.commit('set_img_status', 'finished')
            vm.UploadFlag = 0
            Indicator.close()
          }
        })
        .catch((err) => {
          Indicator.close()
          alert('图片上传失败，请重新上传！')
          vm.imgUrlPaths = []
          vm.$store.commit('set_img_status', 'ready')
          vm.empty()
        })
      //   Indicator.open()
      // this.axiosBaseApi
      //   .get('https://fc.yndyt.net/policy?bucket_name=inquiry-ol')
      //   .then((res) => {
      //     if (res.status === 200) {
      //       const post = res.data
      //       const type = file.type.substr(file.type.indexOf('/') + 1)
      //       const obj = String(new Date().getTime()) + String(Math.floor(Math.random() * 10000))
      //       const storeAs = `Uploads/file/${obj}.${type}`
      //       const form = new FormData()
      //       form.append('name', post.name)
      //       form.append('key', storeAs)
      //       form.append('OSSAccessKeyId', post.ossKeyId)
      //       form.append('policy', post.policy)
      //       form.append('signature', post.sign)
      //       form.append('success_action_status', '200')
      //       form.append('file', file)
      //       console.log(form, 311321)
      //       this.axiosBaseApi
      //         .post('https://inquiry.ynhdkc.com', form)
      //         .then((result) => {
      //           console.log(storeAs, 123131)
      //           vm.imgUrlPaths.push(storeAs)
      //           vm.UploadFlag += 1
      //           if (vm.UploadFlag === vm.imgStore.length && vm.imgStore.length !== 0) {
      //             vm.$store.commit('set_img_paths', vm.imgUrlPaths)
      //             vm.filesOrigin = []
      //             vm.indexOrigin = 0
      //             vm.$store.commit('set_img_status', 'finished')
      //             vm.UploadFlag = 0
      //             Indicator.close()
      //           }
      //         })
      //         .catch((err) => {
      //           Indicator.close()
      //           alert('图片上传失败，请重新上传！')
      //           vm.imgUrlPaths = []
      //           vm.$store.commit('set_img_status', 'ready')
      //           vm.empty()
      //         })
      //     } else {
      //       Indicator.close()
      //       vm.$toast(res.statusText)
      //     }
      //   })
      //   .catch((e) => {
      //     Indicator.close()
      //     vm.$toast(e)
      //   })
    },
    // 移除图片
    remove(index) {
      this.filesCompress = this.filesCompress.filter((file) => {
        return file.key !== index
      })
      this.filesOrigin = this.filesOrigin.filter((file) => {
        return file.key !== index
      })
      this.$store.commit('set_img_upload_cache', this.filesOrigin)
      this.$store.commit('set_img_upload_cache_origin', this.filesOrigin)
      this.$store.commit('set_img_upload_cache_compress', this.filesCompress)
    },
    // 清空图片
    empty() {
      this.filesCompress.splice(0, this.filesCompress.length)
      this.filesOrigin.splice(0, this.filesOrigin.length)
      this.$store.commit('set_img_upload_cache', [])
      this.$store.commit('set_img_upload_cache_origin', [])
      this.$store.commit('set_img_upload_cache_compress', [])
      this.$store.commit('set_img_paths', [])
      this.UploadFlag = 0
    }
  },
  beforeCreate() {
    this.$store.commit('set_img_status', 'ready') // 更新文件上传状态
  },
  destroyed() {
    this.$store.commit('set_img_upload_cache', [])
    this.$store.commit('set_img_upload_cache_compress', [])
    this.$store.commit('set_img_upload_cache_origin', [])
    this.$store.commit('set_img_paths', [])
  },
  watch: {
    imgStatus() {
      if (this.imgStatus === 'uploading') {
        this.submit()
      }
    },
    imgStore() {
      if (this.imgStore.length <= 0) {
        this.$store.commit('set_img_status', 'ready') // 更新文件上传状态
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles/base.less';
.imgUploader {
  margin: 1em 0 0;
  border: 1px solid #e5e5e5;
  .file-list {
    padding: 10px 0px;
    &::after {
      content: '';
      display: block;
      clear: both;
      visibility: hidden;
      line-height: 0;
      height: 0;
      font-size: 0;
    }
    .file-item {
      float: left;
      position: relative;
      width: 100px;
      text-align: center;
      img {
        width: 80px;
        height: 80px;
        /*border: 1px solid #ececec;*/
      }
      .file-remove {
        position: absolute;
        right: 12px;
        top: 4px;
        width: 14px;
        height: 14px;
        color: white;
        cursor: pointer;
        line-height: 12px;
        border-radius: 100%;
        transform: rotate(45deg);
        background: rgba(0, 0, 0, 0.5);
      }
      .flie-loading {
        position: absolute;
        left: 0;
        right: 0;
        top: 2em;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.5);
      }
      .flie-finished {
        position: absolute;
        left: 0;
        right: 0;
        top: 2em;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.5);
      }
      &:hover .file-remove {
        display: inline;
      }
      .file-name {
        margin: 0;
        height: 40px;
        word-break: break-all;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
  .add {
    width: 80px;
    height: 80px;
    margin-left: 10px;
    float: left;
    text-align: center;
    line-height: 75px;
    font-size: 30px;
    border: 0;
    cursor: pointer; /*
      border: 1px dashed @bd_color;*/
    color: @sub_color;
    position: relative;
    span {
      /*position: relative;
        .fa {
          font-size: 1.4em;
          color: #7DD2D9;
        }
        .fa-camera-font{
          font-size: 0.45rem;
          height: 0.6rem;
          line-height: 0.6rem;
          width: 2rem;
          position: absolute;
          bottom: -1.2em;
          right: -0.38rem;
        }*/
      display: block;
      width: 100%;
      height: 100%;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
  .uploadBtn {
    position: relative;
    .originCheckbox {
      display: flex;
      align-items: center;
      margin: 1em;
    }
    .empty {
      position: absolute;
      right: 0;
      bottom: 0;
      background-color: @main_color;
      color: #fff;
      padding: 0.2em 1em;
    }
  }
}
input[type='file'] {
  position: absolute;
  left: 0;
  top: 0;
  width: 80px;
  height: 80px;
  border: 1px solid #000;
  opacity: 0;
}
</style>
